// The information architecture (DESIGN §2) as data: the firm rail and the engagement workspace tabs. The shell, the command
// palette and the e2e route walk all read these lists, so a new page is added here once.
import type { IconName } from "../components/icons";
import type { Role } from "../data/types";

export interface RailItem { to: string; label: string; icon: IconName; group?: "firm"; minRole?: Role; keywords?: string }

/** The firm-level rail (Home, Clients, Action center) and, with group "firm", the one "Firm" menu for everything else. */
export const RAIL: RailItem[] = [
  { to: "/", label: "Home", icon: "home", keywords: "board engagements approvals questions" },
  { to: "/clients", label: "Clients", icon: "users", keywords: "clients engagements" },
  { to: "/actions", label: "Action center", icon: "inbox", keywords: "questions blocked approvals issues client requests" },
  { to: "/inbox", label: "Decisions inbox", icon: "check", group: "firm", keywords: "decisions approvals proposals keyboard" },
  { to: "/engagements", label: "Engagement list", icon: "briefcase", group: "firm", keywords: "portfolio risk deadlines" },
  { to: "/queue", label: "Engine work queue", icon: "layers", group: "firm", keywords: "queue my work next" },
  { to: "/requests", label: "Clients & requests", icon: "chat", group: "firm", keywords: "pbc client requests threads" },
  { to: "/agents", label: "Agents", icon: "bot", group: "firm", keywords: "runs activity" },
  { to: "/firm/registers", label: "Registers", icon: "book", group: "firm", keywords: "licences cpe independence peer review" },
  { to: "/firm/quality", label: "Quality", icon: "shield", group: "firm", minRole: "partner", keywords: "sqms monitoring" },
  { to: "/firm/front-office", label: "Front office", icon: "door", group: "firm", keywords: "prospects proposals pipeline" },
  { to: "/firm/checks", label: "Checks", icon: "check", group: "firm", keywords: "system checks double checks" },
  { to: "/firm/healing", label: "Self-healing", icon: "heart", group: "firm", minRole: "partner", keywords: "firm healing findings repair" },
  { to: "/firm/researcher", label: "Researcher", icon: "flask", group: "firm", keywords: "research currency proposals" },
  { to: "/firm/learning", label: "Learning", icon: "spark", group: "firm", minRole: "partner", keywords: "learning candidates guidance" },
  { to: "/firm/time", label: "Time & billing", icon: "clock", group: "firm", minRole: "manager", keywords: "time billing hours budgets invoices" },
];

/** The engagement rail (Workspace 2): `path` is relative to /e/:id. */
export const ENGAGEMENT_SECTIONS: Array<{ path: string; label: string; icon: IconName }> = [
  { path: "", label: "Overview", icon: "home" },
  { path: "folders", label: "Folders", icon: "folder" },
  { path: "workpapers", label: "Workpapers", icon: "file" },
  { path: "statements", label: "Statements", icon: "layers" },
  { path: "documents", label: "Client docs", icon: "clip" },
  { path: "questions", label: "Client questions", icon: "help" },
  { path: "actions", label: "Action center", icon: "inbox" },
  { path: "activity", label: "Activity", icon: "clock" },
];

/** Engagement workspace tabs; `path` is relative to /e/:id/details ("Engine details"). `stream` names the workstream that completes it. */
export const ENGAGEMENT_TABS = [
  { path: "", label: "Overview", stream: "W4" },
  { path: "flow", label: "Flow", stream: "W4" },
  { path: "file", label: "File", stream: "W4" },
  { path: "evidence", label: "Evidence", stream: "W4" },
  { path: "planning", label: "Planning", stream: "W4" },
  { path: "areas", label: "Areas", stream: "W4" },
  { path: "single-audit", label: "Single audit", stream: "W4" },
  { path: "completion", label: "Completion", stream: "W4" },
  { path: "client", label: "Client", stream: "W5" },
  { path: "agents", label: "Agents", stream: "W4" },
  { path: "health", label: "Health", stream: "W4" },
  { path: "release", label: "Release", stream: "W4" },
] as const;
